import React from "react"

const KnowledgeLinkButton = ({ link, text = "View full article" }) => (
    <a
        target="_blank"
        rel="noopener noreferrer"
        href={link}
        className="btn btn-primary"
        style={{ marginRight: "5px" }}
    >
        {text}
    </a>
)

export default KnowledgeLinkButton
